import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { TankListComponent } from 'src/app/modules/tank/pages/tank-list/tank-list.page';
var ɵ0 = {
    permissions: ['canReadDocumentsList']
};
var routes = [
    {
        path: 'list',
        component: TankListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var TankRoutingModule = /** @class */ (function () {
    function TankRoutingModule() {
    }
    return TankRoutingModule;
}());
export { TankRoutingModule };
export { ɵ0 };
